import React from 'react';

import MainTemplate from '../mainTemplate';
import LogContainer from '../../shared/logs';
import { ReactTitle } from 'react-meta-tags';

const ProviderLogContainer = () => {

  return <MainTemplate>
    <ReactTitle title={`Logs de Auditoria - Reverse Factoring`} />
    <div className="client-log-container">
      <LogContainer />
    </div>
  </MainTemplate>;
}

export default ProviderLogContainer;